const StudentGradesRow = ({
    student,
    score,
    phone,
}: {
    student: string;
    score: number;
    phone: string;
}) => {

    return (
        <>
            <tr>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                    <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                        {student}
                    </div>
                </td>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                    <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                        {phone}
                    </div>
                </td>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                    <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                        {score}
                    </div>
                </td>
            </tr>
        </>
    );
};

export default StudentGradesRow;
